module.exports = __webpack_public_path__ + "static/under-the-big-top-e9893a8731afe1802753bb3e05d520d7.jpg";